import { defineStore } from 'pinia'
import { Channel, utils } from 'frontendcommon-3'
import axios from 'axios'
const SERVER_ERROR_TITLE = 'Server error'

const { softColor } = utils.ColorUtils
let notificationCounter = 0

export const useShellStore = defineStore('shellStore', {
  state: () => ({
    settingsShell: false,
    settingsItemId: '',
    sidebarLoading: false,
    customization: null,
    notifications: [],
    farmacloudMigrationUrl: '',
    tokens: {},
    sidebar: [],
    sidebarSize: 'default',
    showSidebar: true,
    micros: [],
    currentMicro: { id: null },
    userInfo: {},
    fullLoader: false,
    agreementProps: {}
  }),
  getters: {
    getMicroById (state) {
      return (id) => {
        return state.micros.find(micro => micro.id === id)
      }
    }
  },
  actions: {
    async goToZendesk (url) {
      try {
        const { data } = await axios.create().post(url, {
          firstname: this.userInfo.first_name,
          email: this.userInfo.email
        }, { withCredentials: true })
        window.open(data.url, '_blank')
      } catch (err) {
        console.error(err)
        Channel.emitAddServerError('No se ha podido cargar la página de ayuda.')
      }
    },
    // notifications
    ADD_NOTIFICATION (notification) {
      notificationCounter++
      const notificationObj = { ...notification, id: notificationCounter }
      this.notifications.push(notificationObj)
    },
    ADD_SERVER_ERROR (description) {
      this.ADD_NOTIFICATION({ title: SERVER_ERROR_TITLE, description, type: 'error' })
    },
    ADD_NOTIFICATION_SUCCESS (notification) {
      this.ADD_NOTIFICATION({ ...notification, type: 'success' })
    },
    REMOVE_NOTIFICATION (id) {
      const index = this.notifications.findIndex((notification) => notification.id === id)
      if (index >= 0) this.notifications.splice(index, 1)
    },
    // tokens
    SET_TOKENS (payload) {
      this.tokens = payload
    },
    UPDATE_TOKENS (payload) {
      this.tokens[payload.tokenType] = payload.tokens
    },
    SET_TOKEN_FARMAPREMIUM (payload) {
      this.tokens = payload
    },
    // sidebar
    SET_SIDEBAR_LOADING (payload) {
      this.sidebarLoading = payload
    },
    SET_SIDEBAR_SIZE (payload) {
      this.sidebarSize = payload
    },
    SET_SHOW_SIDEBAR (payload) {
      this.showSidebar = payload
    },
    SET_SIDEBAR (payload) {
      this.sidebar = payload
    },
    // micros
    SET_MICROS (payload) {
      this.micros = payload
    },
    SET_CURRENT_MICRO (payload) {
      this.currentMicro = payload
    },
    // settings shell
    SET_SETTINGS_SHELL (payload) {
      this.settingsShell = payload
    },
    SET_SETTINGS_ITEM_ID (payload) {
      this.settingsItemId = payload
    },
    // user info
    SET_USER_INFO (payload) {
      this.userInfo = payload
    },
    // agreement
    SET_AGREEMENT_PROPS (payload) {
      this.agreementProps = {
        ...this.agreementProps,
        ...payload
      }
    },
    // farmacloud
    SET_FARMACLOUD_MIGRATION_URL (url) {
      this.farmacloudMigrationUrl = url
    },
    // customization
    SET_CUSTOMIZATION (payload) {
      const customizationObj = {
        logo: payload.logo_color,
        logoSmall: payload.logo_small_color,
        logoUrl: payload.link_logo_url,
        colors: `
          :root {
            --fc-brand-01: ${payload.primary_color};
            --fc-brand-01-soft: ${softColor(payload.primary_color, 10)};
            --fc-brand-01-medium: ${softColor(payload.primary_color, 50)};
            --fc-brand-01-dark: ${softColor(payload.primary_color, 70)};
            --fc-brand-02: ${payload.secondary_color};
            --fc-brand-02-soft: ${softColor(payload.secondary_color, 10)};
            --fc-brand-02-medium: ${softColor(payload.secondary_color, 50)};
            --fc-brand-02-dark: ${softColor(payload.secondary_color, 70)};
          }`
      }
      this.customization = customizationObj
    },
    // full loader
    SET_FULL_LOADER (payload) {
      this.fullLoader = payload
    }
  }
})
